/* istanbul ignore file */

import PaymentWrapper from "./PaymentWrapper";
import PaymentsWrapper from "./PaymentsWrapper";
import PaymentButtonWrapper from "./PaymentButtonWrapper";
import StripeScriptLoader from "./stripe/ScriptLoader";
import PaypalPlus from "./paypal/Plus";
import GenericStripePayment from "./stripe/GenericPayment";
import CreditCards from "./stripe/CreditCards";

export default {
  "payment-wrapper": PaymentWrapper,
  "payments-wrapper": PaymentsWrapper,
  "payment-button-wrapper": PaymentButtonWrapper,
  "stripe-script-loader": StripeScriptLoader,
  "payment-paypal-plus": PaypalPlus,
  "payment-stripe-generic": GenericStripePayment,
  "payment-credit-card": CreditCards,
};
